export { APP_ROUTE_BASE, APP_ROUTE_V2 } from 'paths';
export const ROUTE = '/*';

export const THANK_YOU_PAGE_URL = '/thank-you';
export const THANK_YOU_PAGE_ROUTE = `${THANK_YOU_PAGE_URL}${ROUTE}`;
export const THANK_YOU_PAGE_URL_SUCCESS = '/thank-you-success/';
export const THANK_YOU_PAGE_URL_FAILED = '/thank-you-failed/';
export const AWAITS_NEXT_ACTION = 'awaits-next-action';

export const APP_ROUTE_NOT_FOUND = '/404';
export const APP_ROUTE_NOT_FOUND_ROUTE = `${APP_ROUTE_NOT_FOUND}${ROUTE}`;
export const ERROR_500 = '/500';
export const ERROR_500_ROUTE = `${ERROR_500}${ROUTE}`;
export const ERROR_URL = '/error';
export const ERROR_ROUTE = `${ERROR_URL}${ROUTE}`;
export const EXPIRED_ROUTE = `/expired${ROUTE}`;
export const CONNECTORS_ERROR_PAGE = '/general-error';
export const CONNECTORS_ERROR_PAGE_ROUTE = `${CONNECTORS_ERROR_PAGE}${ROUTE}`;

export const DISBURSE = '/disburse';
export const BENEFICIARY = '/beneficiary';
export const DISBURSE_ROUTE = `${DISBURSE}${ROUTE}`;
export const BENEFICIARY_ROUTE = `${BENEFICIARY}${ROUTE}`;
export const BENEFICIARY_TOKENIZATION = `${DISBURSE}${BENEFICIARY}`;
export const BENEFICIARY_TOKENIZATION_THANK_YOU = `${BENEFICIARY_TOKENIZATION}${THANK_YOU_PAGE_URL}`;
export const BENEFICIARY_TOKENIZATION_ERROR = `${BENEFICIARY_TOKENIZATION}${ERROR_URL}`;
export const DISBURSE_CARD_TOKENIZATION = `${DISBURSE}/card`;
export const HOSTED_DISBURSE_CARD_TOKENIZATION = `${DISBURSE_CARD_TOKENIZATION}/hosted`;
export const HOSTED_DISBURSE_CARD_TOKENIZATION_ROUTE = `${HOSTED_DISBURSE_CARD_TOKENIZATION}${ROUTE}`;

export const COLLECT = '/collect';
export const CARD_TOKENIZATION = `${COLLECT}/card`;
export const CARD_TOKENIZATION_ROUTE = `${CARD_TOKENIZATION}${ROUTE}`;
export const HOSTED_CARD_TOKENIZATION = `${CARD_TOKENIZATION}/hosted`;
export const HOSTED_CARD_TOKENIZATION_ROUTE = `${HOSTED_CARD_TOKENIZATION}${ROUTE}`;
export const CARD_MANAGEMENT = '/card_management';
export const CARD_MANAGEMENT_ROUTE = `${CARD_MANAGEMENT}${ROUTE}`;
export const CARD_TOKENIZATION_CARD_MANAGEMENT = `${CARD_TOKENIZATION}${CARD_MANAGEMENT}`;
export const CARD_TOKENIZATION_ERROR = `${CARD_TOKENIZATION}${ERROR_URL}`;

export const ISSUING = '/issuing';
export const CARD_DETAILS = '/card_details';
export const ACTIVATE_CARD = '/activate_card';
export const RESET_PIN = '/reset_pin';
export const SET_KBA = '/set_kba';
export const PIN = '/pin';
export const ISSUING_ROUTE = `${ISSUING}${ROUTE}`;
export const CARD_ISSUING_DETAILS = `${ISSUING}${CARD_DETAILS}`;
export const CARD_DETAILS_ROUTE = `${CARD_DETAILS}${ROUTE}`;

export const CARD_ISSUING_ACTIVATE = `${ISSUING}${ACTIVATE_CARD}`;
export const CARD_ACTIVATE_ROUTE = `${ACTIVATE_CARD}${ROUTE}`;

export const CARD_ISSUING_ACTIVATE_THANK_YOU = `${CARD_ISSUING_ACTIVATE}${THANK_YOU_PAGE_URL}`;
export const CARD_ACTIVATE_THANK_YOU_ROUTE = `${ACTIVATE_CARD}${THANK_YOU_PAGE_ROUTE}`;

export const CARD_ISSUING_ERROR = `${CARD_ISSUING_DETAILS}${ERROR_URL}`;
export const CARD_ISSUING_RESET_PIN = `${ISSUING}${RESET_PIN}`;
export const RESET_PIN_ROUTE = `${RESET_PIN}${ROUTE}`;

export const CARD_ISSUING_RESET_PIN_THANK_YOU = `${CARD_ISSUING_RESET_PIN}${THANK_YOU_PAGE_URL}`;
export const RESET_PIN_THANK_YOU = `${RESET_PIN}${THANK_YOU_PAGE_ROUTE}`;

export const CARD_ISSUING_SET_KBA = `${ISSUING}${SET_KBA}`;
export const SET_KBA_ROUTE = `${SET_KBA}${ROUTE}`;
export const CARD_ISSUING_ACTIVATE_SET_KBA = `${CARD_ISSUING_ACTIVATE}${SET_KBA}`;
export const CARD_ACTIVATE_SET_KBA_ROUTE = `${ACTIVATE_CARD}${SET_KBA_ROUTE}`;
export const CARD_ISSUING_SET_KBA_THANK_YOU = `${CARD_ISSUING_SET_KBA}${THANK_YOU_PAGE_URL}`;
export const SET_KBA_THANK_YOU_ROUTE = `${SET_KBA}${THANK_YOU_PAGE_ROUTE}`;
export const CARD_ISSUING_VIEW_PIN = `${ISSUING}${PIN}`;
export const VIEW_PIN_ROUTE = `${PIN}${ROUTE}`;
export const CARD_ISSUING_VIEW_PIN_THANK_YOU = `${CARD_ISSUING_VIEW_PIN}${THANK_YOU_PAGE_URL}`;
export const VIEW_PIN_THANK_YOU = `/pin${THANK_YOU_PAGE_ROUTE}`;

export const IDV = '/idv';
export const DOCS = '/docs';

export const IDV_ROUTE = `${IDV}${ROUTE}`;
export const IDV_THANK_YOU = `${IDV}${THANK_YOU_PAGE_URL}`;
export const IDV_EXPIRED = `${IDV}/expired`;
export const IDV_ERROR = `${IDV}/error`;
export const IDV_DOCS = `${IDV}${DOCS}`;
export const DOCS_ROUTE = `${DOCS}${ROUTE}`;

export const SUBSCRIPTION = '/subscription';
export const SUBSCRIPTION_ROUTE = `${SUBSCRIPTION}${ROUTE}`;
export const SUBSCRIPTION_THANK_YOU = `${SUBSCRIPTION}${THANK_YOU_PAGE_URL}`;

export const THREE_DS_PAYMENT_ROUTE = `/3ds-payment${ROUTE}`;
export const COMPLETE_BANK_PAYMENT_ROUTE = `/complete-bank-payment${ROUTE}`;
export const COMPLETE_BANK_REDIRECT_ROUTE = `/complete-bank-redirect${ROUTE}`;

export const OTP = '/otp';
export const OTP_ROUTE = `${OTP}${ROUTE}`;

export const PAY = '/pay';
export const PAY_SHORTLINK = `${PAY}/:hash${ROUTE}`;

export const HOSTED_PAGE_PREVIEW = '/hosted/preview';
export const HOSTED_PAGE_PREVIEW_ROUTE = `${HOSTED_PAGE_PREVIEW}${ROUTE}`;

export const REUSABLE_LINK = `${COLLECT}/payments`;
export const REUSABLE_LINK_ROUTE = `${REUSABLE_LINK}${ROUTE}`;

export const REUSABLE_LINK_ERROR = `${REUSABLE_LINK}${ERROR_URL}`;

export const CUSTOMER_TOKENIZATION_ROUTE = '/customer';
export const CUSTOMER_ROUTE = `${CUSTOMER_TOKENIZATION_ROUTE}${ROUTE}`;
export const CUSTOMER_TOKENIZATION_THANK_YOU_ROUTE = `${CUSTOMER_TOKENIZATION_ROUTE}${THANK_YOU_PAGE_URL}`;
export const CUSTOMER_TOKENIZATION_ERROR_ROUTE = `${CUSTOMER_TOKENIZATION_ROUTE}${ERROR_URL}`;

export const PAYOUT_TRACKER_PAGE = '/payout_tracker';
export const PAYOUT_TRACKER_ROUTE = `${PAYOUT_TRACKER_PAGE}${ROUTE}`;

export const VALITOR = '/valitor';
export const VALITOR_ROUTE = `${VALITOR}${ROUTE}`;
export const VALITOR_ERROR = `${VALITOR}${ERROR_URL}`;
export const VALITOR_ERROR_ROUTE = `${VALITOR_ERROR}${ROUTE}`;

export const MOBILE_ROUTES = {
  PAYMENT_CATEGORIES: '/',
  PAYMENT_METHOD_TYPES: '/payment-method-types',
  ADD_CARD: '/add-card',
  EDIT_CARD: '/edit-card',
  CARDS_VIEW: '/saved-cards',
  REQUIRED_FIELDS: '/required-fields',
  REVIEW: '/review',
  THANK_YOU: '/thank-you',
  THANK_YOU_PAGE_URL_SUCCESS: '/thank-you-success/',
  THANK_YOU_PAGE_URL_FAILED: '/thank-you-failed/',
  IDV: 'idv',
  BANK_PAYMENT_METHODS_VIEW: '/saved-bank-payment-methods'
};

export const STATIC_PAGES_ROUTES = `/static-pages${ROUTE}`;
export const STATIC_PAGE_OTP_ROUTE = '/otp';
export const STATIC_PAGE_PAYMENT_SUCCESS_ROUTE = '/payment-success';
export const STATIC_PAGE_UPLOAD_FILE_ROUTE = '/upload-file';

export const DEMO = '/demo';
export const DEMO_ROUTE = `${DEMO}${ROUTE}`;
